import { Stack, Switch, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

// ----------------------------------------------------------------------

export const FoceApiHeader = () => {
	const { state, actions } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack gap={0.5}>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Typography variant={"h6"}>{translate("Forzar inicio conexión por API")}</Typography>
				<Switch
					checked={state.forceSecureConnection}
					onChange={(e) => actions.onSetForceSecureConnection(e.target.checked)}
				/>
			</Stack>
			<Typography variant='body2' color='text.secondary'>
				{translate(
					"Al activar esta opción, todos los flujos de primera conexión que se hagan en tu aplicación de Finlink deben iniciarse con un token obtenido desde la API, como se explica en la documentación."
				)}
			</Typography>
		</Stack>
	);
};

export default FoceApiHeader;
